import React from 'react';
import styled from 'styled-components';
import {FormattedMessage} from 'react-intl';
import {FieldArray, formValueSelector} from 'redux-form';
import {
    FORM_ATTACHMENTS_SECTION,
    FORM_FIELD_ATTACHMENTS,
    FORM_FIELD_NEW_ATTACHMENTS,
    FORM_TICKET_SECTION
} from '../../../../../../constants/formConstants';
import {validTicketFiles} from '../../../../../common/validationCommons';
import {connect} from 'react-redux';
import {downloadAttachment} from '../../../../../../actions/orders/actionAttachments';
import moment from 'moment';
import RenderDropZone from '../../../../../common/RenderDropZone';
import UploadedAttachments from './UploadedAttachments';
import formMessages from "../../../../../../intl/sparePartsOrders/formMessages";
import {moduleRoles} from '../../../../../../utils/roles';

const StyledDiv = styled.div`
  border-radius: 5px;
`;

const compare = (a, b) => {
    return moment(a.created).isAfter(b.created) ? 1 : -1;
};

// const AttachmentSection = (props) => {
//     const { attachments = {}, userRights, readOnly, form } = props;
//     const dealerAttachments = Object.keys(attachments).map(item => attachments[item]).filter(item => item.isDealer).sort(compare);
//     const editorAttachments = Object.keys(attachments).map(item => attachments[item]).filter(item => item.isEditor).sort(compare);
const AttachmentSection = ({attachments = {}, userRights, readOnly, form, roles}) => {

    const canReadAttachment = (attachment) => {
        if (moduleRoles.isEditorOrder(roles) || moduleRoles.isSGEditorOrder(roles) || !attachment.solutionGroup) {
            return true;
        }
        return attachment.solutionGroup.canForwardToDealer;
    }

    const dealerAttachments = Object.keys(attachments)
        .map(item => attachments[item])
        .filter(item => item.isDealer)
        .sort(compare);

    const editorAttachments = Object.keys(attachments)
        .map(item => attachments[item])
        .filter(item => item.isEditor)
        .filter(item => canReadAttachment(item))
        .sort(compare);

    return (
        <>
            {((userRights.canAddAttach && !readOnly) || (attachments && Object.keys(attachments).length > 0)) &&
            <>
                <h3 className="text-left mt-4 ml-4">
                    <FormattedMessage {...formMessages.ATTACHMENTS_SECTION}/>
                </h3>
                <StyledDiv className="border border-secondary bg-white overflow-hidden">
                    {(dealerAttachments && dealerAttachments.length > 0) && <UploadedAttachments
                        attachments={dealerAttachments} label={formMessages.DEALER_ATTACHMENTS} form={form}/>
                    }
                    {(editorAttachments && editorAttachments.length > 0) && <UploadedAttachments
                        attachments={editorAttachments} label={formMessages.EDITOR_ATTACHMENTS} form={form}/>
                    }
                    {userRights.canAddAttach && !readOnly && <FieldArray
                        name={FORM_FIELD_NEW_ATTACHMENTS}
                        component={RenderDropZone}
                        validate={validTicketFiles}/>
                    }
                </StyledDiv>
            </>
            }
        </>
    )
};

const mapStateToProps = (state, initialProps) => ({
    attachments: formValueSelector(initialProps.form)(state, `${FORM_ATTACHMENTS_SECTION}.${FORM_FIELD_ATTACHMENTS}`),
    ticketId: formValueSelector(initialProps.form)(state, `${FORM_TICKET_SECTION}.uuid`),
    roles: state.profile.userDetail.roles,
});

export default connect(mapStateToProps, {
    downloadAttachment,
})(AttachmentSection);
